import { useQuery } from '@tanstack/react-query';

type SimpleClient = {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress?: string | null;
};

export type FamilyMemberDetections = {
  client: SimpleClient;
  detections: unknown[];
  isProcessed: boolean;
};

type FamilyFileDetections = {
  fileId: string;
  familyId: string;
  members: FamilyMemberDetections[];
};

type Options = { enabled?: boolean; autoRefresh?: boolean };

const DETECTIONS_POLL_INTERVAL_MS = 5000;

export function useFamilyFileDetections(
  familyId: string | undefined,
  fileId: string | undefined,
  { enabled = true, autoRefresh = false }: Options = {},
) {
  const { data, isLoading } = useQuery<FamilyFileDetections>({
    queryKey: ['families', familyId, 'data-upload-files', fileId, 'detections'],
    enabled: enabled && !!familyId && !!fileId,
    // Member rows only appear once detection runs, and a recording may produce none
    // at all, so polling is driven by the file's processing state (the caller passes
    // autoRefresh while it runs) rather than waiting for rows that may never arrive.
    refetchInterval: autoRefresh ? DETECTIONS_POLL_INTERVAL_MS : false,
  });

  return { members: data?.members ?? [], isLoading };
}
